import React from 'react';
import { usePlanningActualState } from '../Context/index';

const BuyingMarginTotal = ({ years }) => {
  const { checkVisible, getOvarAllFieldTotal } = usePlanningActualState();
  const buyingMargin = [
    {
      keyName: 'plannedBuyingMargin',
      name: 'Planned Buying Margin (%)',
    },
    {
      keyName: 'actualBuyingMargin',
      name: 'Actual Buying Margin (%)',
    },
  ];
  return (years ?? []).map((currentYear, yearIndex) => {
    return (
      <table key={yearIndex} className="table custom-table layout-fixed  font-13 mr-3">
        <thead>
          <tr>
            {buyingMargin.map((salesItem, i) => {
              const isVisible = checkVisible(salesItem.keyName);
              return (
                isVisible && (
                  <th key={i} className="w-200px">
                    <span>
                      {currentYear}&nbsp;
                      {salesItem.name}
                    </span>
                  </th>
                )
              );
            })}
          </tr>
        </thead>
        <tbody>
          <tr>
            {buyingMargin.map((salesItem, i) => {
              const isVisible = checkVisible(salesItem.keyName);
              return isVisible && <td key={i}>{getOvarAllFieldTotal(salesItem.keyName, yearIndex, currentYear)}</td>;
            })}
          </tr>
        </tbody>
      </table>
    );
  });
};
export default BuyingMarginTotal;
